import * as React from 'react';
import { SuccessMessageIcon } from '../svg/SuccessMessageIcon';
var SuccessMessage = function (props) { return (React.createElement("div", { className: "mt-3 flex items-center font-primary text-[14px] font-semibold leading-5 text-black" },
    React.createElement("div", { className: "mr-2 flex h-10 w-10 flex-row items-center justify-center rounded-full border-2 border-solid border-grass mobile:h-7.5" },
        React.createElement(SuccessMessageIcon, null)),
    React.createElement("span", null, props.text))); };
export default SuccessMessage;
